<template>
	<el-card>
		<el-table ref="multipleTable" :data="postList" tooltip-effect="dark">
			<el-table-column prop="id" label="ID" width="50">
			</el-table-column>
			<el-table-column prop="uid" label="发布人" width="200">
				<template slot-scope="scope">
					<div style="display: flex;align-items: center;">
						<el-avatar style="margin-right: 10px;" :src="scope.row.userInfo.avatar"></el-avatar>
						<span>{{scope.row.userInfo.nickname}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="内容" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="read_count" label="阅读量">
			</el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="添加时间">
			</el-table-column>
			<el-table-column>
				<template slot-scope="scope">
					<el-button @click="commentPost(scope.row.id,scope.$index)" type="primary" plain>评论</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
			layout="total,prev,pager,next" :total="postLength">
		</el-pagination>
		<!-- 评论弹窗 -->
		<el-dialog title="评论" :visible.sync="commentDialogVisible" width="70%">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="马甲用户">
					<span style="margin-right: 10px;color: #999;">{{userName}}</span>
					<el-button @click="userDialogVisible = true">选择</el-button>
				</el-form-item>
				<el-form-item label="内容" prop="title">
					<el-input type="textarea" v-model="form.content" placeholder="请输入评论内容"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">发布
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 选择马甲弹窗 -->
		<el-dialog title="选择马甲" :visible.sync="userDialogVisible" width="70%">
			<el-table ref="multipleTable" :data="userList">
				<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="sex" label="性别"> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column width="200px;">
					<template slot-scope="scope">
						<el-button type="primary" @click="onUser(scope.row.uid,scope.$index)">选择</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleUserCurrentChange" :current-page="usercurrentPage" :page-size="pagesize"
				layout="total,prev,pager,next,jumper" :total="userLength">
			</el-pagination>
		</el-dialog>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				userName: "请选择马甲",
				currentPage: 1,
				usercurrentPage: 1,
				pagesize: 0,
				postList: [],
				postLength: 0,
				userDialogVisible: false,
				commentDialogVisible: false,
				btnLoading: false,
				btnDisabled: false,
				userList: [],
				userLength: 0,
				form: {
					uid: "",
					post_id: "",
					content: ""
				}
			}
		},
		created() {
			this.handleCommunityList();
			this.getUserList();
		},
		methods: {
			onSubmit() {
				this.btnLoading = false;
				this.btnDisabled = false;

				this.$H.post("post/vestCommentAdd", this.form).then(res => {
					if (res.code == 200) {
						this.$message.success("操作成功");
						this.commentDialogVisible = false;
					}
				})
			},
			onUser(uid, index) {
				this.form.uid = uid;
				this.userName = this.userList[index].nickname;
				this.userDialogVisible = false;
			},
			handleCommunityList() {
				this.$H.get("post/list", {
					page: this.currentPage,
				}).then((res) => {
					this.postList = res.result.data;
					this.pagesize = res.result.per_page;
					this.postLength = res.result.total;
				})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.handleCommunityList();
			},
			handleUserCurrentChange(usercurrentPage) {
				this.usercurrentPage = usercurrentPage;
				this.getUserList();
			},
			commentPost(id, index) {
				this.form.post_id = id;
				this.commentDialogVisible = true;
			},
			getUserList() {
				this.$H
					.get("user/list", {
						page: this.usercurrentPage,
						type: 2
					})
					.then((res) => {
						this.userList = res.result.data;
						this.userLength = res.result.total;
						this.pagesize = res.result.per_page;
					});
			}
		}
	}
</script>

<style>
</style>
